export const CNPJ_LENGTH = 14
